import React, { useEffect, useState } from "react";
import { Row, Col, Card, Spin, Space, Typography } from "antd";
import { Link } from "react-router-dom";
import Title from "antd/es/typography/Title";
import { apiCaller } from "src/util/apiCaller";
import {
  UserOutlined,
  CalendarOutlined,
  FolderOpenOutlined,
  PlayCircleOutlined,
  DoubleRightOutlined,
} from "@ant-design/icons";

const { Text, Paragraph } = Typography;

interface DocumentData {
  idTulieu: string;
  anhDaiDien: string;
  tenTuLieu: string;
  moTa: string;
  historicalPeriod?: string;
  culturalType?: string;
  productType?: string;
  ngayDang?: string;
  tacGia?: string;
}

const VideoSliderHome: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [documents, setDocuments] = useState<DocumentData[]>([]);
  const [currentPage, setCurrentPage] = useState(1);

  const fetchHistoricalDocuments = async (page: number) => {
    setLoading(true);
    try {
      const response = await apiCaller({
        url: `/apipublic/tulieuhienthis?isvideo=true&page=1&size=4&properties_sort=id&type_sort=desc`,
        method: "GET",
      });

      if (response?.data) {
        const { content } = response.data;
        const formattedDocuments = content.map((doc: any) => ({
          idTulieu: doc.id,
          anhDaiDien: doc.anhDaiDien,
          tenTuLieu: doc.tenTuLieu,
          moTa: doc.moTa,
          historicalPeriod: doc.loaiTuLieu.tenLoaiTuLieu || "",
          culturalType: doc.culturalType,
          productType: doc.productType,
          ngayDang: doc.ngayDang,
          tacGia: doc.tacGia,
        }));

        setDocuments((prev) => [...prev, ...formattedDocuments]);
      }
    } catch (error) {
      console.error("Error fetching documents:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHistoricalDocuments(currentPage);
  }, [currentPage]);

  const loadMore = () => {
    setCurrentPage((prev) => prev + 1);
  };

  if (loading && documents.length === 0) {
    return (
      <div style={{ textAlign: "center", padding: "20px" }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div style={{ marginBottom: "20px" }} className="QTI-list-detail-container">
      <Title level={2} className="QTI-slider-home-title">
        Video
        <div
          style={{
            textAlign: "right",
            marginTop: 18,
            fontSize: 13,
            fontStyle: "italic",
            color: "#1677ff",
          }}
        >
          <Link to={`/trang-chu/video`} onClick={() => localStorage.setItem("currentMenuKey", "video")}>
            Xem thêm <DoubleRightOutlined />
          </Link>
        </div>
      </Title>
      <Row gutter={[16, 16]}>
        {documents.slice(0, 4).map((document) => (
          <Col xs={24} sm={12} md={6} lg={6} key={document.idTulieu}>
            <Link 
              to={`/trang-chu/video/${document.idTulieu}/chi-tiet`} 
              onClick={() => localStorage.setItem("currentMenuKey", "video")}
            >
              <Card
                className="QTI-slider-home-card"
                hoverable
                style={{ position: "relative", padding: "12px" }}
                cover={
                  <div
                    style={{ position: "relative" }}
                    className="QTI-slider-home-card__cover"
                  >
                    <img
                      alt={document.tenTuLieu}
                      src={document.anhDaiDien}
                      style={{ height: 200, objectFit: "cover", width: "100%" }}
                    />
                    <PlayCircleOutlined
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        fontSize: "32px",
                        color: "white",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        borderRadius: "50%",
                        padding: "10px",
                      }}
                    />
                  </div>
                }
              >
                <Card.Meta
                  className="card-meta-custom"
                  title={document.tenTuLieu}
                  description={
                    <Space
                      size={16}
                      style={{ display: "flex", flexWrap: "wrap" }}
                    >
                      {document.tacGia && (
                        <Text strong style={{ fontSize: "12px" }}>
                          <UserOutlined />
                          {document.tacGia.length > 10
                            ? `${document.tacGia.slice(0, 10)}...`
                            : document.tacGia}
                        </Text>
                      )}
                      {document.ngayDang && (
                        <Text type="secondary" style={{ fontSize: "12px" }}>
                          <CalendarOutlined />{" "}
                          {new Date(document.ngayDang).toLocaleDateString(
                            "vi-VN"
                          )}
                        </Text>
                      )}
                      {document.historicalPeriod && (
                        <Text type="secondary" style={{ fontSize: "12px" }}>
                          <FolderOpenOutlined /> {document.historicalPeriod}
                        </Text>
                      )}
                    </Space>
                  }
                />
                <Paragraph type="secondary" className="QTI-mota-trang-chu">
                  {document.moTa}
                </Paragraph>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
      {/* {documents.length < 10 && (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <Button onClick={loadMore} loading={loading}>
            Load More
          </Button>
        </div>
      )} */}
    </div>
  );
};

export default VideoSliderHome;
